var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.31,385c16.55-18.42,28.9-40.77,37.07-64.25,11.65-33.5,15.25-69.34,15.3-104.81.06-34.4-3.25-69.29-15.48-101.43S400.07,53,369.72,36.78c-53.43-28.48-115-15.45-162.3,19-23.28,16.95-42.72,39.41-58.85,63.14-17.33,25.49-41.57,45.33-62.81,67.43C73.79,198.8,62.5,212,53.54,226.86c-29.27,48.49-30.9,103.21,15.7,140.67C116.6,405.59,189,430.08,248.88,435.76c43.54,4.13,89.5-3.88,124.93-29.52A149.13,149.13,0,0,0,397.31,385Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,385c16.55-18.42,28.9-40.77,37.07-64.25,11.65-33.5,15.25-69.34,15.3-104.81.06-34.4-3.25-69.29-15.48-101.43S400.07,53,369.72,36.78c-53.43-28.48-115-15.45-162.3,19-23.28,16.95-42.72,39.41-58.85,63.14-17.33,25.49-41.57,45.33-62.81,67.43C73.79,198.8,62.5,212,53.54,226.86c-29.27,48.49-30.9,103.21,15.7,140.67C116.6,405.59,189,430.08,248.88,435.76c43.54,4.13,89.5-3.88,124.93-29.52A149.13,149.13,0,0,0,397.31,385Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 441.23,
    y1: 292.98,
    x2: 463.02,
    y2: 284.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.82,
    y1: 432.54,
    x2: 432.02,
    y2: 296.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.93,
    y1: 442.3,
    x2: 58.87,
    y2: 437.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-5--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 227.5 157.72 306.34 157.72 114.25 366.88 35.42 366.88 227.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.58,161.59V162l-2.52,1v-.62c0-2.18-.9-3.12-2.87-2.38s-2.94,2.43-2.94,5v5.42a6.43,6.43,0,0,1,3.91-4.06c3.11-1.17,4.49.55,4.49,4v3.67a8.31,8.31,0,0,1-5.53,8.2c-3.73,1.41-5.56-.32-5.56-4V165.92c0-3.84,1.73-6.87,5.56-8.32S191.58,157.89,191.58,161.59Zm-8.33,12.2v3.63c0,2.17.9,3.15,2.87,2.41a4.48,4.48,0,0,0,2.87-4.58v-3.63c0-2.17-.93-3.14-2.87-2.41A4.46,4.46,0,0,0,183.25,173.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,160.73a8.26,8.26,0,0,1,5.53-8.17c3.73-1.41,5.56.28,5.56,4V169a8.31,8.31,0,0,1-5.56,8.21c-3.7,1.4-5.53-.33-5.53-4Zm2.66,11.64c0,2.18.93,3.14,2.87,2.41a4.44,4.44,0,0,0,2.87-4.57V157.42c0-2.21-.9-3.19-2.87-2.44a4.49,4.49,0,0,0-2.87,4.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.4,151v7.64a5.23,5.23,0,0,1-3.46,5.21c-2.35.88-3.45-.26-3.45-2.61v-7.63a5.24,5.24,0,0,1,3.45-5.21C213.29,147.46,214.4,148.63,214.4,151Zm-5.19,1.85v7.88c0,1.31.49,2,1.73,1.53a2.76,2.76,0,0,0,1.73-2.83V151.5c0-1.32-.52-2-1.73-1.56A2.77,2.77,0,0,0,209.21,152.8Zm13.17-8.63L212.84,172l-1.62.61,9.54-27.79Zm3.91,11.32v7.6a5.19,5.19,0,0,1-3.46,5.21c-2.35.89-3.45-.25-3.45-2.6v-7.61a5.2,5.2,0,0,1,3.45-5.17C225.22,152,226.29,153.17,226.29,155.49Zm-5.19,1.85v7.84c0,1.32.52,2,1.73,1.56a2.79,2.79,0,0,0,1.73-2.86V156c0-1.31-.52-2-1.73-1.52A2.75,2.75,0,0,0,221.1,157.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 188.38 168.2 256.26 168.2 259.37 352.9 191.49 352.9 188.38",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 170.66 168.2 238.55 168.2 241.65 352.9 173.77 352.9 170.66",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 152.95 168.2 220.83 168.2 223.94 352.9 156.05 352.9 152.95",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 135.23 168.2 203.12 168.2 206.22 352.9 138.34 352.9 135.23",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.54 161.02 234.54 164.12 352.9 120.62 352.9 117.52 234.54 161.02",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.54 143.3 234.54 146.41 352.9 102.91 352.9 99.8 234.54 143.3",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.54 125.59 234.54 128.69 352.9 85.19 352.9 82.08 234.54 125.59",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,60.07c-3.23,12.16-10.18,35.79-19.81,55.05-13.6,27.2-55.85,78.68-85.48,103.94s-78.93,55.56-78.93,55.56l184.22-67Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,274S324.37,191.52,351.16,62.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.39,
    y1: 130.59,
    x2: 168.39,
    y2: 282.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.65,
    y1: 277.57,
    x2: 354.97,
    y2: 206.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.1,
    y1: 271.1,
    x2: 181.1,
    y2: 277.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.6,
    y1: 266.5,
    x2: 193.6,
    y2: 272.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.11,
    y1: 261.91,
    x2: 206.11,
    y2: 268.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.62,
    y1: 257.31,
    x2: 218.62,
    y2: 263.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.13,
    y1: 252.71,
    x2: 231.13,
    y2: 258.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.63,
    y1: 248.12,
    x2: 243.63,
    y2: 254.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.14,
    y1: 243.52,
    x2: 256.14,
    y2: 249.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.65,
    y1: 238.92,
    x2: 268.65,
    y2: 245.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.16,
    y1: 234.32,
    x2: 281.16,
    y2: 240.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.66,
    y1: 229.73,
    x2: 293.66,
    y2: 235.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.17,
    y1: 225.13,
    x2: 306.17,
    y2: 231.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.68,
    y1: 220.53,
    x2: 318.68,
    y2: 226.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.19,
    y1: 215.94,
    x2: 331.19,
    y2: 222.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.7,
    y1: 211.34,
    x2: 343.7,
    y2: 217.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3,
    y1: 206.79,
    x2: 355.3,
    y2: 212.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 132.97,
    x2: 226.87,
    y2: 115.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 140.89,
    x2: 226.87,
    y2: 123.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.17,
    y1: 148.81,
    x2: 226.87,
    y2: 131.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.63 319.82 214.85 326.14 214.85 316.78 231.63 310.45 231.63 319.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.68 305.89 251.9 312.22 251.9 302.85 268.68 296.53 268.68 305.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.73 291.97 288.95 298.29 288.95 288.93 305.73 282.6 305.73 291.97",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.78 278.04 326 284.36 326 275 342.78 268.68 342.78 278.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-4--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.15 92.38 378.65 111.41 378.65 65.03 429.15 46 429.15 92.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.38,
    y1: 61.2,
    x2: 399.24,
    y2: 53.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.38,
    y1: 57.98,
    x2: 399.24,
    y2: 50.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.38,
    y1: 54.75,
    x2: 399.24,
    y2: 47.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "383.55 104.59 389.11 92.09 399.42 92.48 408.55 71.46 420.06 72.05 426.2 54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 74.04,
    x2: 425.61,
    y2: 57.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 79.79,
    x2: 425.61,
    y2: 63.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 85.54,
    x2: 425.61,
    y2: 68.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 91.3,
    x2: 425.61,
    y2: 74.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 97.05,
    x2: 425.61,
    y2: 80.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.57,
    y1: 102.8,
    x2: 425.61,
    y2: 86.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.29,
    cy: 45.95,
    rx: 23.1,
    ry: 18.02,
    transform: "translate(42.72 186.63) rotate(-48.55)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.28,27.65c-3.66-2.54-8.57-3.45-14-2.1V46Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.19,
    y1: 40.33,
    x2: 279.54,
    y2: 31.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.19,
    y1: 36.72,
    x2: 279.54,
    y2: 28.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.19,
    y1: 33.11,
    x2: 279.54,
    y2: 24.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "141.05 134.15 84.51 155.46 84.51 103.54 141.05 82.23 141.05 134.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.04 94.33 126.04 134.24 135.54 130.66 135.54 90.75 126.04 94.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.31 143.19 111.58 139.69 111.58 109.13 102.31 112.62 102.31 143.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.44 101.89 114.17 105.39 114.17 138.71 123.44 135.22 123.44 101.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.71 102.35 90 106 90 147.82 99.71 144.16 99.71 102.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.21,
    y1: 99.24,
    x2: 107.57,
    y2: 90.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.21,
    y1: 95.64,
    x2: 107.57,
    y2: 87.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.21,
    y1: 92.03,
    x2: 107.57,
    y2: 83.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.48,164.23l.18.64,16.61,57.27L351,276.58,363.12,287l.57,34.17,4.06,15.64,5.21-4.06-2.9-13.9,1.16-34.74,9.85,1.15,5.21,28.38,13.9,32.43L399,328.7l-3.47-16.8,4.05-136.67-19.11-13.9s2.32-12.16-5.21-17.37-16.22-3.48-18,2.31-.57,14.48,0,16.22,1.16,9.26,1.16,9.26l6.95,8.69-4.05,4.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.91,278s-.75,13.89,2.07,22.52,5.63,30,5.63,30,.37,10.13.37,12.95,5.07,7.31,6.19,5.62a11.73,11.73,0,0,0,1.69-10.32c-1.5-5.06-3.38-9.57-3.38-10.13s1.88-24.58,1.69-29.46-.94-9.38-.94-11.63V275.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.86,338.81c-.59-2-1.24-3.91-1.82-5.53l.13,5.53-5.06.76-1.32-3.69c.09,2.91.19,6.2.19,7.63,0,2.81,5.07,7.31,6.19,5.62A11.73,11.73,0,0,0,405.86,338.81Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,273.33a83.9,83.9,0,0,0-1.87,16.7c0,8.63,3.75,35.46,3.75,35.46s-4.88,5.07-6.38,7.51-4.32,4.13-3,5.63,5.25-.57,7.5-1.13,3.38-3,4.32-4.31,2.81-2.07,3.19-5.26a35.13,35.13,0,0,0,.19-5.82c0-.75.37-13.13,1.31-20.07s2.44-16.14,2.44-23.08S374,273.33,374,273.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,327a10.76,10.76,0,0,1-4.31,4.13l-3.76-1.31-.33,0a30.82,30.82,0,0,0-2.48,3.22c-1.5,2.44-4.32,4.13-3,5.63s5.25-.57,7.5-1.13,3.38-3,4.32-4.31,2.81-2.07,3.19-5.26c.15-1.33.21-2.42.23-3.31A26.66,26.66,0,0,0,380.34,327Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,220.44s-4.5,9.95-4.5,16.33-1.13,30.91-1.13,30.91a27.22,27.22,0,0,0,14.26,12c10.32,3.94,29.65-3.57,29.65-3.57s.75-34.12,0-40.31S407,222.69,407,222.69l-34.53-6.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,220.44l.55.45a67.15,67.15,0,0,0,14.09,8.37c8.63,3.75,21,1.69,21,1.69l2.63-24.77,8.63-29.64L389.54,169s-8.63,17.08-9.76,22.33-1.69,12.2-1.88,13.7S371,220.44,371,220.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.37,165.09l-5.86-1.67s-3.55-3.76-4-5.23-2.72-2.51-1.46-2.71a3.32,3.32,0,0,1,2.93.83c.62.63.83,1.47,1.46,1.88s1.67-.21,1.46-.83-2.51-4.39-2.92-5.23-2.72-2.72-2.72-3.76,1.25,0,2.09.41,4.39,4.81,5.43,5.23a10,10,0,0,1,3.77,3.14,18.45,18.45,0,0,1,1.88,4.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.61,167s-17.46-1.69-18.77-.94-16.51,12.57-16.51,12.57l-19.89-18-3.94,3.75,22.33,29.08,14.26-4.12s.56,9.19.94,12.19-2.44,7.88-4.69,12.76-8.64,15.57-8.64,15.57,1.51,3.57,3,4.51,4.5,2.63,4.5,2.63,6.38-19.71,7.69-24.59,2.63-7.88,2.82-9.94,10.13-24.21,10.13-24.21Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.09,
    y1: 189.3,
    x2: 377.53,
    y2: 176.54,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,166.48a51.78,51.78,0,0,0-7.4,10.43c-3.19,6.38-5.07,26.46-4.88,28.33,0,.25.05.51.06.75a18.53,18.53,0,0,0,.88-3.56c.19-2.06,10.13-24.21,10.13-24.21L397.61,167S395.17,166.73,392.06,166.48Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.33,
    y1: 178.6,
    x2: 358.95,
    y2: 180.85,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.29,159.46S395,164,395,165.84s-4.88,13.32-4.88,13.32l12,5.26s6-14.08,6.19-15.76-1.5-6.76-.37-13.51,1.87-7.7-.38-8.07-11.45,1.12-13.13,3.56A10.42,10.42,0,0,0,393.29,159.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.91 159.51 394.49 163.62 393.79 161.04 398.91 159.51",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.49,168.09s-8.26,18.2-11.64,25.9-5.25,12-5.25,13.88-2.25,34.71-2.25,34.71a16.48,16.48,0,0,0,6.57,3.94,21.51,21.51,0,0,0,12-.18c3.19-.94,7.5-5.63,7.5-5.63s-4.5-29.46-4.5-30,4.69-14.08,5.63-15.77,8.25-15.76,8.63-17.07S408.49,168.09,408.49,168.09Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.85,194c-3.37,7.69-5.25,12-5.25,13.88a135.14,135.14,0,0,0,13.14-17.64A158.81,158.81,0,0,0,414,170.91c-3.05-1.59-5.52-2.82-5.52-2.82S400.23,186.29,396.85,194Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,206.18s-.38-3.19-.38-4.5a6.2,6.2,0,0,1,.75-2.63,23.75,23.75,0,0,0,2.44,8.63c2.06,3.57,3.19,5.63,3.19,5.63S364.77,208.81,364.21,206.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.4,218v-4.31s-5.62-1.69-8.25-2.82-6.94-4.69-6.94-4.69,2.81,6.76,3.94,8.26,1.87,4.69,2.81,6a30.32,30.32,0,0,1,2.25,5.26,19.1,19.1,0,0,0,2.82,2.62,20,20,0,0,0,6.38,3.38L379.22,221Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,219.69h-4.13L379.4,218l-.18,3-7.51-.38s-1.69-.19.19,1.13a23.21,23.21,0,0,1,3.56,3c.75.75,1.69,2.44,3.57,2.44s6.94-2.44,8.07-2.44,3.75-1.69,3.75-1.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,194.76l3.13,19.76-26.26,4.61,1.5,6s36,.45,37.18.26-1.53-42.66-1.53-42.66.19-5.26,0-6.19-6.75-2.82-6.75-2.82",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,136.35s2.95-4.93,5.42-5.59,6.07,0,7.72,3,1.31,10.19,0,12.16-4.93,2.62-7.23,2-4.76-3-5.09-5.09S415.18,136.35,415.18,136.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.17,158.36s6.08-.49,8.38-3,7.06-6.73,5.42-14.12-6.24-9.69-9.86-11.17-9,.82-9,.82-.62.34-1.49.89c-.47.18-1.79.68-3.11,1.08-1.64.49-3.12.66-3,2.46a1.9,1.9,0,0,0,.55,1.1,3.8,3.8,0,0,0-.38.71c-1.15,2.79-1.81,6.9-2.14,7.56s-3.78,1.15-3.78,2.13,1.65,3.62,1.65,3.62,0,9,.32,10.18,7.23-.16,7.23-.16l3.94-1,1.22-.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.21,157.54s2.24.33,4.8.57c2-.35,5.05-1.11,6.54-2.71,2.3-2.46,7.06-6.73,5.42-14.12s-6.24-9.69-9.86-11.17-9,.82-9,.82-.62.34-1.49.89c-.47.18-1.79.68-3.11,1.08-1.64.49-3.12.66-3,2.46a1.9,1.9,0,0,0,.55,1.1s.11,1.2,2.41,2a19.5,19.5,0,0,0,3.45,1,7.5,7.5,0,0,0-.17,6.57,24.13,24.13,0,0,0,3.45,5.42s2-2.79,3.62-1a4.47,4.47,0,0,1,.16,5.74C403.84,157.87,401.21,157.54,401.21,157.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,145.23c-.11.73-.49,1.27-.86,1.22s-.57-.69-.46-1.42.49-1.27.85-1.22S392.18,144.5,392.08,145.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,141.75s1.48-.4,1.89,1.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,422.76l-79.46,1.5.41-8.52c.59-3,1.3-6.85,1.54-9.25.45-4.52,3.66-27.69,4-28.89s4.36-18.63,4.52-19.34l3.24-10.62c1,6.66,4,27.09,4,33.46,0,6.94.34,19.57,2.6,26.14.12.34.23.71.34,1.09l.32,7.53,23.09,3,.6-2.7-7.8-6.29-.52-7.26c.21-8,.55-17,1-20.37.85-6.18,2.56-40.5,2.58-40.85s-1.43,6.6-1.68,1.55a4.94,4.94,0,0,0,2.38-3.18,39.51,39.51,0,0,0,.69-4.87c1.62-1.63,5.54-6,9.19-10.24,9-10.54,9-11.75,9-12.15,0-2.24-3.25-9.71-3.39-10l-13.35-30c-.09-.63-.7-4.93-2.22-7.4a15.92,15.92,0,0,0-4.24-3.87c-3.28-3.05-8.09-7.18-8.93-7.18h0c-.5-.11-2.78-2.16-4.61-4a15.15,15.15,0,0,0-2.87-2.07l.75-2.87a15.55,15.55,0,0,0,3.17-1c1.23-.61,2-3.94,3.3-9.78l.31-1.37a34.1,34.1,0,0,0,.59-9,15.31,15.31,0,0,0,1.58-5.21,34.38,34.38,0,0,0,.14-5.51c-.21-3.26-3.54-5.53-5.51-6.59-3-1.6-7-2.69-8.68-1.74A7.61,7.61,0,0,0,107,209h-.42a16.22,16.22,0,0,0-7.5,3.76c-.4.39-.83.77-1.27,1.16-2.67,2.35-6,5.28-4.74,14.27.49,3.45,4.49,11.52,5.66,12.7.18.17.32.34.47.51l-.4,2.7c-3.54-.29-6.56-.25-7.42.61-.65.65-3.86,1.85-5.78,2.57-.75.28-1.38.52-1.74.67s-1.1.36-2,.62c-3,.84-7.54,2.12-8.81,3.87s-13.76,24.68-18.26,33.85A22.86,22.86,0,0,0,53.44,289a3.77,3.77,0,0,0-.32.93,4.53,4.53,0,0,0-.2,2.52c.72,2.14,20.71,21.16,22.26,22.54,1.92,1.71,4.72,3.87,4.75,3.89a.47.47,0,0,0,.3.1h.12s.35-.1.78-.26l-4.38,15.33a.52.52,0,0,0,.13.48A28.65,28.65,0,0,0,81.7,338c.1,7.17,2,18.49,2,20.11,0,.66-.19,3.62-.43,7.35-.45,7.21-1.08,17.09-1.08,21.43,0,5,1.05,20.08,1.78,28.84l.67,12.12,91.27-.28ZM133.93,309.17l1.24,1.61c-.33.63-.83,1.59-1.43,2.76C133.8,312.56,133.87,311.05,133.93,309.17Zm-62-19.27c1.76-2,3.32-4,4.11-5.1l6.94,18.57c0,.31.2,1.84.29,3.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,197.72a35.71,35.71,0,0,1-.39,11c-1.18,5.31-2.16,10.23-3.34,10.82a16.26,16.26,0,0,1-3.35,1l-1,3.73-14.95-2.36,1-6.69S164.68,195.56,174.32,197.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,185.36s-4.49.87-7.25,3.63-7.3,4.8-5.87,15c.48,3.42,4.49,11.39,5.53,12.42s1.2,1.9,4.48,2.59,8.81.87,9.67.35,2.22-3.37,4.47-6.3,3.34-8.53,3.34-10.43a3,3,0,0,1,.43-1.52,16.25,16.25,0,0,0,2.32-6.54,32.83,32.83,0,0,0,.14-5.42c-.34-5.52-11-9.32-13.46-7.94a7.24,7.24,0,0,0-3.11,4.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,214.92s-1.34,1.51-1.84-.33a10.74,10.74,0,0,1,.34-4.67s0-2,1-1.84.83,4.17.83,4.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,261.37s-3,4.94-2.36,6.87,20.18,20.62,22.11,22.34,4.73,3.86,4.73,3.86,3.43-.86,4.08-3.43a41.88,41.88,0,0,0,.86-4.3L122.7,264.38l-5.58-3.22",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.51,311.84s.43,32.21.43,34.14-1.5,22.12-1.5,28.78,1.93,32.21,2.36,35-1.07,6.23.86,7.73,5.8,1.72,7.3,0,.43-9.88.43-9.88,1.93-9,2.36-13.31,3.65-27.7,4.08-29S155.34,346,155.34,346l3.87-12.67s4.29,27.92,4.29,35.65.43,19.75,2.58,26,4.08,22.34,4.08,22.34-.65,6.44-.65,7.73,1.72,2.57,3.22,2.57H176a11.54,11.54,0,0,0,2.79-1.29l5.8-.85c2.79-.43,7.73-2.58,9.44-3.44s3.23-3.65,2.37-3.65-12.46-2.58-13.53-2.79l-1.08-.22a35.42,35.42,0,0,1,0-4.94c.22-1.93-.85-2.14-.85-5.58s.42-28.56,1.28-34.79,2.58-40.8,2.58-40.8.43-10.52-.64-16.53a73.51,73.51,0,0,0-3.44-12s-18.25,1.07-27.92-.43a92.93,92.93,0,0,1-16.1-3.86S134.73,307.11,134.51,311.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,265.88c0-1.38,18.21-35.1,19.78-37.27s9.25-3.74,10.62-4.33,6.69-2.36,7.68-3.34,6.29-.79,14,.39,11.41,4.92,11.41,4.92,4.13,4.13,4.91,4.13,10.83,8.66,11.61,10,.23,42.1-.36,49.57-3,9.64-4.56,12.59-9,17.12-9.83,17.51-16.76,1.32-26.79-2-14.82-7.94-14.82-7.94,5.41-18.95,6.19-21.7,0-9.25,0-9.25l-7.28-19.47s-6.49,9.24-10.23,10.42",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.62,283.71c.78,1.15,1.58,2.25,2.39,3.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,257.36a161.43,161.43,0,0,0,11.73,23.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,244.78s2.4,12,5.09,19.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,242.64c-.19-1.24-.34-2.39-.43-3.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,259.7s-1.73-6.67-3-13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83,305s-3.93,5.9-3.93,6.68-.79,3-.4,3.55,7.09,4.13,7.87,3.93a4.93,4.93,0,0,0,3.74-3.54,45.61,45.61,0,0,0,.79-6.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,311.63s4.72,3.74,5.51,3.55S180,312,180,312s1.18,1,.79-1.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.6,
    y1: 314,
    x2: 185.54,
    y2: 316.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.59,267.84l14.51,18.81s-9.64,18.3-9,20.66,7.08,4.52,8.26,3.73S206,290.58,206,288.42s-3.35-9.84-3.35-9.84l-13.37-30.1s-.59-4.72-2.17-7.28-7.28-5.7-7.28-5.7",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.1,
    y1: 286.65,
    x2: 191.55,
    y2: 291.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,255.26s4.5-7.48,10.78-7.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,300s-9.45,12.24-10.31,13.1-4.08,6.65-4.08,6.65l6.66,2.79S177.24,309.47,182,300Z",
    style: {
      fill: "#8a8a8a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,222.5s16.75-.43,28.78,5.59",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.27,365.43s-2.26,6.2-7,7.05S261,364,266.33,359.23,279,362.05,281.27,365.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,335s-7,17.19-4.22,25.64,20.29,14.66,25.36,3.67-6.2-26.49-10.43-29.87S290,332.18,288.59,335Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,342.33s-12.12,11-13.53,22,6.76,14.93,15.22,13.52,12.68-22.82,10.14-32.69S329.74,342.33,329.74,342.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,403.19s-13.52.57-14.09,7.05,5.92,7.89,12.4,2.25S337.63,403.48,332,403.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,416.72s-1.41,6.76-6.48,9.3-14.09-2.82-9.3-11S295.92,413.34,298.46,416.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,395.59s-2.53-5.64-12.4-2-13.8,9.3-7.61,11.28S286.62,395.59,286.62,395.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,328s1.69,3.95,5.07,3.1,4.23-5.91,9.59-4.5,9.86,7.6,9.86,4.79-6.76-10.15-14.37-10.15S315.08,324.29,314.8,328Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.35 460.86 294.11 468.3 294.11 468.3 291.53 442.68 316.94 433.27 314.35 460.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.94 433.27 327.91 441.23 302.5 450.63 291.53 442.68 316.94 433.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.28 434.92 324.68 441.02 303.81 448.77 295.4 442.67 316.28 434.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.86,370.52s5.9,17.26,7.16,32,0,38.32,0,38.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.49,376.41s-6.73,19.79-8.42,32.43-2.1,32-2.1,32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,411.78s-2.95.85-4.64,29.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,416.72s2.82-2.41,4.51,3.06.84,20.64.84,20.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,414c2.21,12.34.17,26,.17,26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,395.59s12.14-2.33,17.19,11.14a38.68,38.68,0,0,1,1.27,4.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26,382.53s2.54-5.63,12.4-2,13.81,9.3,7.61,11.27S337.26,382.53,337.26,382.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,385a17.51,17.51,0,0,0-6.4,8.68c-5.06,13.47-4.48,46.74-4.48,46.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26,382.53a15.62,15.62,0,0,0-8.4,1.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,374a39.83,39.83,0,0,1,7.14,12.91c6.74,19.37,9.27,44.21,8,53.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,365.43s5.87.92,11.82,7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.67,392.16c-.41,24.44-.7,48.68-.7,48.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,328s-1.31-1.22-2.15,20.67c-.33,8.51-.65,24.33-.93,40.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.32 468.82 305.08 476.26 305.08 476.26 302.5 450.63 327.91 441.23 325.32 468.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.5 450.63 291.53 442.68 294.11 468.3 305.08 476.26 302.5 450.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.b422cb5646096ff0dce17514c7a19d1d.svg";
export { ForwardRef as ReactComponent };